/**
 * @ngdoc object
 * @name auth.controller:AuthCtrl
 *
 * @description
 *
 */
angular
    .module('festzelt-os.auth')
    .controller('LogoutCtrl', [
        '$auth',
        'locale',
        '$state',
        'Alert',
        'Users',
        '$translate',
        LogoutCtrl
    ]);

function LogoutCtrl($auth, locale, $state, Alert, Users, $translate) {

    // this.translate = $translate;

    locale.ready('auth').then(function () {
        logout();
    });

    function logout() {
        const translatedValue = (path) => {
            return $translate.instant(`auth.success_logout.${path}`);
        };

        $auth.logout().then(function () {
            Users.dispatch('logout');
            Alert.animatedAlert(
                translatedValue('title'),
                translatedValue('content'),
                'success',
                {
                    confirmButtonText: translatedValue('confirm'),
                    showCancelButton: false,
                }
            );
            $state.go('auth.login');
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/auth/controllers/auth-logout-controller.js